import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DebtSummaryComponent } from './components/debt/debt-summary/debt-summary.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthService } from './auth/auth.service';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { PayInFullComponent } from './components/payment/pay-in-full/pay-in-full.component';
import { LabelModule } from '@progress/kendo-angular-label';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { PayByArrangementComponent } from './components/payment/pay-by-arrangement/pay-by-arrangement.component';
import { NavBarComponent } from './components/nav/nav-bar/nav-bar.component';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { ContactUsComponent } from './components/contact/contact-us/contact-us.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormWizardComponent } from './components/form/form-wizard/form-wizard.component';
import { FormsModule } from '@angular/forms';
import { TextInputElementComponent } from './components/form/text-input-element/text-input-element.component';
import { DateInputElementComponent } from './components/form/date-input-element/date-input-element.component';
import { SeparatorElementComponent } from './components/form/separator-element/separator-element.component';
import { CheckboxElementComponent } from './components/form/checkbox-element/checkbox-element.component';
import { HeadingElementComponent } from './components/form/heading-element/heading-element.component';
import { ParagraphElementComponent } from './components/form/paragraph-element/paragraph-element.component';
import { TextAreaInputElementComponent } from './components/form/text-area-input-element/text-area-input-element.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { BearerTokenInterceptor } from './helpers/bearer-token-interceptor';
import { FooterComponent } from './components/footer/footer.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LoadingDialogComponent } from './components/dialog/loading-dialog/loading-dialog.component';
import { ProcessingDialogComponent } from './components/dialog/processing-dialog/processing-dialog.component';
import { RequestErrorInteceptor } from './helpers/request-error-inteceptor';
import { ManualSummaryComponent } from './components/payment/manual-summary/manual-summary.component';
import { BpaySummaryComponent } from './components/payment/bpay-summary/bpay-summary.component';
import { ErrorDialogComponent } from './components/dialog/error-dialog/error-dialog.component';
import { ErrorComponent } from './components/error/error.component';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { PaymentSuccessfulComponent } from './components/payment/payment-successful/payment-successful.component';
import { SelectAllElementComponent } from './components/form/select-all-element/select-all-element.component';
import { AppConfigService } from './services/app-config.service';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { DropDownListElementComponent } from './components/form/drop-down-list-element/drop-down-list-element.component';
import { SendPaymentReceiptComponent } from './components/payment/send-payment-receipt/send-payment-receipt.component';
import { MaskedTextInputElementComponent } from './components/form/masked-text-input-element/masked-text-input-element.component';
import { AddressInputElementComponent } from './components/form/address-input-element/address-input-element.component';
import { EditAddressDialogComponent } from './components/dialog/edit-address-dialog/edit-address-dialog.component';
import { NabCardPaymentDialogComponent } from './components/dialog/nab-card-payment-dialog/nab-card-payment-dialog.component';
import { PaymentProcessComponent } from './components/payment/payment-process/payment-process.component';
import { HtmlElementComponent } from './components/form/html-element/html-element.component';
import { MwCardPaymentDialogComponent } from './components/dialog/mw-card-payment-dialog/mw-card-payment-dialog.component';
import { TcnChatComponent } from './components/tcn-chat/tcn-chat.component';

@NgModule({
  declarations: [
    AppComponent,
    DebtSummaryComponent,
    LoginComponent,
    PayInFullComponent,
    PayByArrangementComponent,
    NavBarComponent,
    ContactUsComponent,
    FormWizardComponent,
    TextInputElementComponent,
    DateInputElementComponent,
    SeparatorElementComponent,
    CheckboxElementComponent,
    HeadingElementComponent,
    ParagraphElementComponent,
    TextAreaInputElementComponent,
    LogoutComponent,
    FooterComponent,
    LoadingDialogComponent,
    ProcessingDialogComponent,
    ErrorComponent,
    ManualSummaryComponent,
    BpaySummaryComponent,
    ErrorDialogComponent,
    PaymentSuccessfulComponent,
    SelectAllElementComponent,
    DropDownListElementComponent,
    SendPaymentReceiptComponent,
    MaskedTextInputElementComponent,
    AddressInputElementComponent,
    EditAddressDialogComponent,
    NabCardPaymentDialogComponent,
    PaymentProcessComponent,
    HtmlElementComponent,
    MwCardPaymentDialogComponent,
    TcnChatComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    InputsModule,
    BrowserAnimationsModule,
    GridModule,
    ButtonsModule,
    LabelModule,
    ProgressBarModule,
    NavigationModule,
    DateInputsModule,
    DropDownsModule,
    ChartsModule,
    DialogsModule,
    GaugesModule
  ],
  providers: [
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: BearerTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestErrorInteceptor, multi: true },
    AppConfigService,
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
